import { render, staticRenderFns } from "./imgList.vue?vue&type=template&id=a9ed57d8&scoped=true&"
import script from "./imgList.vue?vue&type=script&lang=js&"
export * from "./imgList.vue?vue&type=script&lang=js&"
import style0 from "./imgList.vue?vue&type=style&index=0&id=a9ed57d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ed57d8",
  null
  
)

export default component.exports